import { useState } from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx/xlsx.mjs';  



function ExportXlsx() {
    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const TotalSum = useSelector(state => state.RevenueSlice.TotalSum)
    const FirstTotalSum = useSelector(state => state.RevenueSlice.FirstTotalSum)
    const SecondTotalSum = useSelector(state => state.RevenueSlice.SecondTotalSum)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)
    
    const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)
    
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)
    const HoursStaffKashierArray = useSelector(state => state.StaffSlice.HoursStaffKashierArray)
    const HoursStaffCookArray = useSelector(state => state.StaffSlice.HoursStaffCookArray)
    const HoursStaffCookSecondGroupArray = useSelector(state => state.StaffSlice.HoursStaffCookSecondGroupArray)

    const ResultKashier = useSelector(state => state.StaffSlice.ResultKashier)
    const ResultCook = useSelector(state => state.StaffSlice.ResultCook)
    const ResultCookSecondGroup = useSelector(state => state.StaffSlice.ResultCookSecondGroup)
    const ResultManager = useSelector(state => state.StaffSlice.ResultManager)
    const ResultOther = useSelector(state => state.StaffSlice.ResultOther)
    const ResultFOT = useSelector(state => state.StaffSlice.ResultFOT)
    
    const Period = useSelector(state => state.PeriodSlice.Period)
    
    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)
    const WeekDay = useSelector(state => state.MonthSlice.WeekDay)

    const [CancelTouch, setCancelTouch] = useState(false)

    var SheetData = []

    const isNumber = (value) => {
            return typeof value === 'number' && !isNaN(value);
        }


    const getData = async () => {
        
        var RevenueData = []
        var WeekDayData = []
        SheetData = []
        await RevenueData.push(SelectedMonth.Name)
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
            RevenueData.push({t: "n", v: parseInt(el.id) + 1})
            }
            return(el)
        })
        await RevenueData.push('Итого')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push(SelectedMonth.Name)
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            RevenueData.push({t: "n", v: parseInt(el.id) + 1})
            }
            return(el)
        })
        await RevenueData.push('Итого')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await WeekDayData.push('День недели')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(parseInt(WeekDay) + parseInt(el.id) === 1 || parseInt(WeekDay) + parseInt(el.id) === 8 || parseInt(WeekDay) + parseInt(el.id) === 15 || parseInt(WeekDay) + parseInt(el.id) === 22 || parseInt(WeekDay) + parseInt(el.id) === 29 || parseInt(WeekDay) + parseInt(el.id) === 36)
                    return WeekDayData.push('Пн.');
                
                if(parseInt(WeekDay) + parseInt(el.id) === 2 || parseInt(WeekDay) + parseInt(el.id) === 9 || parseInt(WeekDay) + parseInt(el.id) === 16 || parseInt(WeekDay) + parseInt(el.id) === 23 || parseInt(WeekDay) + parseInt(el.id) === 30 || parseInt(WeekDay) + parseInt(el.id) === 37)
                    return WeekDayData.push('Вт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 3 || parseInt(WeekDay) + parseInt(el.id) === 10 || parseInt(WeekDay) + parseInt(el.id) === 17 || parseInt(WeekDay) + parseInt(el.id) === 24 || parseInt(WeekDay) + parseInt(el.id) === 31 || parseInt(WeekDay) + parseInt(el.id) === 38)
                    return WeekDayData.push('Ср.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 4 || parseInt(WeekDay) + parseInt(el.id) === 11 || parseInt(WeekDay) + parseInt(el.id) === 18 || parseInt(WeekDay) + parseInt(el.id) === 25 || parseInt(WeekDay) + parseInt(el.id) === 32 || parseInt(WeekDay) + parseInt(el.id) === 39)
                    return WeekDayData.push('Чт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 5 || parseInt(WeekDay) + parseInt(el.id) === 12 || parseInt(WeekDay) + parseInt(el.id) === 19 || parseInt(WeekDay) + parseInt(el.id) === 26 || parseInt(WeekDay) + parseInt(el.id) === 33 || parseInt(WeekDay) + parseInt(el.id) === 40)
                    return WeekDayData.push('Пт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 6 || parseInt(WeekDay) + parseInt(el.id) === 13 || parseInt(WeekDay) + parseInt(el.id) === 20 || parseInt(WeekDay) + parseInt(el.id) === 27 || parseInt(WeekDay) + parseInt(el.id) === 34  || parseInt(WeekDay) + parseInt(el.id) === 41)
                    return WeekDayData.push('Сб.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 0 || parseInt(WeekDay) + parseInt(el.id) === 7 || parseInt(WeekDay) + parseInt(el.id) === 14 || parseInt(WeekDay) + parseInt(el.id) === 21 || WeekDay + parseInt(el.id) === 28 || parseInt(WeekDay) + parseInt(el.id) === 35  || parseInt(WeekDay) + parseInt(el.id) === 42)
                    return WeekDayData.push('Вс.');        
            }
            return(el)
        })
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('День недели')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(parseInt(WeekDay) + parseInt(el.id) === 1 || parseInt(WeekDay) + parseInt(el.id) === 8 || parseInt(WeekDay) + parseInt(el.id) === 15 || parseInt(WeekDay) + parseInt(el.id) === 22 || parseInt(WeekDay) + parseInt(el.id) === 29 || parseInt(WeekDay) + parseInt(el.id) === 36)
                    return WeekDayData.push('Пн.');
                
                if(parseInt(WeekDay) + parseInt(el.id) === 2 || parseInt(WeekDay) + parseInt(el.id) === 9 || parseInt(WeekDay) + parseInt(el.id) === 16 || parseInt(WeekDay) + parseInt(el.id) === 23 || parseInt(WeekDay) + parseInt(el.id) === 30 || parseInt(WeekDay) + parseInt(el.id) === 37)
                    return WeekDayData.push('Вт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 3 || parseInt(WeekDay) + parseInt(el.id) === 10 || parseInt(WeekDay) + parseInt(el.id) === 17 || parseInt(WeekDay) + parseInt(el.id) === 24 || parseInt(WeekDay) + parseInt(el.id) === 31 || parseInt(WeekDay) + parseInt(el.id) === 38)
                    return WeekDayData.push('Ср.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 4 || parseInt(WeekDay) + parseInt(el.id) === 11 || parseInt(WeekDay) + parseInt(el.id) === 18 || parseInt(WeekDay) + parseInt(el.id) === 25 || parseInt(WeekDay) + parseInt(el.id) === 32 || parseInt(WeekDay) + parseInt(el.id) === 39)
                    return WeekDayData.push('Чт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 5 || parseInt(WeekDay) + parseInt(el.id) === 12 || parseInt(WeekDay) + parseInt(el.id) === 19 || parseInt(WeekDay) + parseInt(el.id) === 26 || parseInt(WeekDay) + parseInt(el.id) === 33 || parseInt(WeekDay) + parseInt(el.id) === 40)
                    return WeekDayData.push('Пт.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 6 || parseInt(WeekDay) + parseInt(el.id) === 13 || parseInt(WeekDay) + parseInt(el.id) === 20 || parseInt(WeekDay) + parseInt(el.id) === 27 || parseInt(WeekDay) + parseInt(el.id) === 34  || parseInt(WeekDay) + parseInt(el.id) === 41)
                    return WeekDayData.push('Сб.');
            
                if(parseInt(WeekDay) + parseInt(el.id) === 0 || parseInt(WeekDay) + parseInt(el.id) === 7 || parseInt(WeekDay) + parseInt(el.id) === 14 || parseInt(WeekDay) + parseInt(el.id) === 21 || WeekDay + parseInt(el.id) === 28 || parseInt(WeekDay) + parseInt(el.id) === 35  || parseInt(WeekDay) + parseInt(el.id) === 42)
                    return WeekDayData.push('Вс.'); 
            }
            return(el)
        })
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await WeekDayData.push('')
        await SheetData.push(WeekDayData)

        await RevenueData.push('Выручка руб.')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
            RevenueData.push({t: "n", v: el.Value})
            }
            return(el)
        })
        await RevenueData.push({t: "n", v: FirstTotalSum})
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('Выручка руб.')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            RevenueData.push({t: "n", v: el.Value})
            }
            return(el)
        })
        await RevenueData.push({t: "n", v: SecondTotalSum})
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push('')
        await RevenueData.push({t: "n", v: TotalSum})
        await SheetData.push(RevenueData)
        RevenueData = []

        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            if(el.id === 15)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Кассир' && el.Hidden !== true)
            {
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.Rate})
                RevenueData.push({t: "n", v: el.Prize})
                RevenueData.push({t: "n", v: el.Shift})
                el.Hours.map((a) => {
                    if(a.id < 15)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.FirstHour})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)) + 
                    el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&
                        item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && 
                        parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                        ?
                        Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.Shift)) 
                        : 
                        Sum + 0, 0) +
                    el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&
                        item.id < 15 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0
                    )
                    ).toFixed(2) 
                })
                RevenueData.push({t: "n", v: el.FirstBonus.Value})
                RevenueData.push({t: "n", v: el.FirstFine.Value})
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.SecondRate})
                RevenueData.push({t: "n", v: el.SecondPrize})
                RevenueData.push({t: "n", v: el.SecondShift})
                el.Hours.map((a) => {
                    if(a.id > 14)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.SecondHour})
                RevenueData.push({
                t: "n",
                v: parseFloat(parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)) + 
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && 
                    parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ? 
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.SecondShift)) 
                    : 
                    Sum + 0, 0) +
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                    ? 
                    Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                    : 
                    Sum + 0, 0
                )
                ).toFixed(2)
                })
                RevenueData.push({t: "n", v: el.SecondBonus.Value})
                RevenueData.push({t: "n", v: el.SecondFine.Value})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour) + parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)) + 
                    el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&
                        RevenueArray.length > 0 && item.Value > 0 && 
                        parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                        ? 
                            item.id < 15 
                            ?
                            Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.Shift)) 
                            :
                            Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.SecondShift)) 
                        : Sum + 0, 0) +
                    el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&
                        RevenueArray.length > 0 && item.Value > 0 && 
                        HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0
                    )
                    ).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await StaffSelectedCityArray.map((el) => {
            if((el.Post === "Повар" || el.Post === "Повар 1 группа") && el.Hidden !== true)
            {
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.Rate})
                RevenueData.push({t: "n", v: el.Prize})
                RevenueData.push({t: "n", v: el.Shift})
                el.Hours.map((a) => {
                    if(a.id < 15)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.FirstHour})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && 
                            parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                            ?
                            Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.Shift)) 
                            : 
                            Sum + 0, 0) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            item.id < 15 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 
                            ? 
                            Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) 
                            : 
                            Sum + 0, 0
                        )
                    ).toFixed(2)
                })
                RevenueData.push({t: "n", v: el.FirstBonus.Value})
                RevenueData.push({t: "n", v: el.FirstFine.Value})
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.SecondRate})
                RevenueData.push({t: "n", v: el.SecondPrize})
                RevenueData.push({t: "n", v: el.SecondShift})
                el.Hours.map((a) => {
                    if(a.id > 14)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.SecondHour})
                RevenueData.push({
                t: "n",
                v: parseFloat(parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)) +
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && 
                    parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ?
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.SecondShift)) 
                    : 
                    Sum + 0, 0) +
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 
                    ? 
                    Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) 
                    : 
                    Sum + 0, 0
                )
                ).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.SecondBonus.Value})
                RevenueData.push({t: "n", v: el.SecondFine.Value})

                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + (parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            RevenueArray.length > 0 && item.Value > 0 && 
                            parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                            ?
                            item.id < 15
                                ?
                                Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.Shift)) 
                                :
                                Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.SecondShift)) 
                            : 
                            Sum + 0, 0) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 
                            ? 
                            Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) 
                            : 
                            Sum + 0, 0
                        )
                    ).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await StaffSelectedCityArray.map((el) => {
            if(el.Post === "Повар 2 группа" && el.Hidden !== true)
            {
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.Rate})
                RevenueData.push({t: "n", v: el.Prize})
                RevenueData.push({t: "n", v: el.Shift})
                el.Hours.map((a) => {
                    if(a.id < 15)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.FirstHour})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            item.id < 15 && RevenueArray.length > 0 && item.Value > 0 && 
                            parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                            ?
                            Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.Shift)) 
                            : 
                            Sum + 0, 0) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            item.id < 15 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 
                            ? 
                            Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) 
                            : 
                            Sum + 0, 0
                        )
                    ).toFixed(2)
                })
                RevenueData.push({t: "n", v: el.FirstBonus.Value})
                RevenueData.push({t: "n", v: el.FirstFine.Value})
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.SecondRate})
                RevenueData.push({t: "n", v: el.SecondPrize})
                RevenueData.push({t: "n", v: el.SecondShift})
                el.Hours.map((a) => {
                    if(a.id > 14)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.SecondHour})
                RevenueData.push({
                t: "n",
                v: parseFloat(parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)) +
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && RevenueArray.length > 0 && item.Value > 0 && 
                    parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ?
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.SecondShift)) 
                    : 
                    Sum + 0, 0) +
                el.Hours.reduce((Sum, item) => 
                    item.id > Period.MinDay && item.id < Period.MaxDay &&
                    item.id > 14 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 
                    ? 
                    Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) 
                    : 
                    Sum + 0, 0
                )
                ).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.SecondBonus.Value})
                RevenueData.push({t: "n", v: el.SecondFine.Value})

                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + (parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            RevenueArray.length > 0 && item.Value > 0 && 
                            parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                            ?
                            item.id < 15
                                ?
                                Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.Shift)) 
                                :
                                Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.SecondShift)) 
                            : 
                            Sum + 0, 0) +
                        el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay &&
                            HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 
                            ? 
                            Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) 
                            : 
                            Sum + 0, 0
                        )
                    ).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Управление')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            if(el.id === 15)
                {
                    RevenueData.push('Управление')
                }
                else
                {
                    RevenueData.push('')
                }
            
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Управляющий' && el.Hidden !== true)
            {
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.Rate})
                RevenueData.push({t: "n", v: el.Prize})
                RevenueData.push({t: "n", v: el.Shift})
                el.Hours.map((a) => {
                    if(a.id < 15)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.FirstHour})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.FirstBonus.Value})
                RevenueData.push({t: "n", v: el.FirstFine.Value})
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.SecondRate})
                RevenueData.push({t: "n", v: el.SecondPrize})
                RevenueData.push({t: "n", v: el.SecondShift})

                el.Hours.map((a) => {
                    if(a.id > 14)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push(el.SecondHour)
                RevenueData.push({
                t: "n",
                v: parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.SecondBonus.Value})
                RevenueData.push({t: "n", v: el.SecondFine.Value})

                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour) + parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Кухрабочие, Стажеры без % и без премии')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Сотрудник')
        await RevenueData.push('Ставка')
        await RevenueData.push('Премия')
        await RevenueData.push('Часов')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
            if(el.id === 15)
                {
                    RevenueData.push('Кухрабочие, Стажеры без % и без премии')
                }
                else
                {
                    RevenueData.push('')
                }
            
            }
            return(el)
        })
        await RevenueData.push('Часов')
        await RevenueData.push('Сумма руб')
        await RevenueData.push('Сумма руб. доп. премии')
        await RevenueData.push('Сумма руб. депремирования')
        await RevenueData.push('Итого за месяц')
        await SheetData.push(RevenueData)
        RevenueData = []

        await StaffSelectedCityArray.map((el) => {
            if(el.Post !== "Управляющий" && el.Post !== "Кассир" && el.Post !== "Повар" && el.Post !== "Повар 1 группа" && el.Post !== "Повар 2 группа" && el.Hidden !== true)
            {
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.Rate})
                RevenueData.push({t: "n", v: el.Prize})
                RevenueData.push({t: "n", v: el.Shift})
                el.Hours.map((a) => {
                    if(a.id < 15)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.FirstHour})
                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.FirstBonus.Value})
                RevenueData.push({t: "n", v: el.FirstFine.Value})
                RevenueData.push(el.FIO)
                RevenueData.push({t: "n", v: el.SecondRate})
                RevenueData.push({t: "n", v: el.SecondPrize})
                RevenueData.push({t: "n", v: el.SecondShift})

                el.Hours.map((a) => {
                    if(a.id > 14)
                    {
                        RevenueData.push({t: "n", v: a.Value})
                    }
                    return(a)
                })
                RevenueData.push({t: "n", v: el.SecondHour})
                RevenueData.push({
                t: "n",
                v: parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)).toFixed(2)
                })

                RevenueData.push({t: "n", v: el.SecondBonus.Value})
                RevenueData.push({t: "n", v: el.SecondFine.Value})

                RevenueData.push({
                    t: "n",
                    v: parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour) + parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        //Касса
        SheetData.push('')

        RevenueData.push('Итого касса руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultKashier.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultKashier.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultKashier.Result[el.id])
                    })
                }
            return(el)
        })

        RevenueData.push('')
        if(isNumber(parseFloat(ResultKashier.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultKashier.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultKashier.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого касса руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultKashier.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultKashier.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultKashier.Result[el.id])
                    })
                }
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultKashier.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultKashier.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultKashier.SecondTotalSum)
            })
        }
        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultKashier.TotalSum)))
            {
                RevenueData.push({
                    t: "n",
                    v: parseFloat(ResultKashier.TotalSum)
                })
            }
            else
            {
                RevenueData.push({
                    t: "s",
                    v: String(ResultKashier.TotalSum)
                })
            }
        SheetData.push(RevenueData)
        RevenueData = []


        //Повара 1 группа        
        RevenueData.push('Итого повара (группа 1) руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultCook.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultCook.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultCook.Result[el.id])
                    })
                }  
            return(el)
        })

        RevenueData.push('')
        if(isNumber(parseFloat(ResultCook.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCook.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCook.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого повара (группа 1) руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultCook.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultCook.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                            t: "s",
                        v: String(ResultCook.Result[el.id])
                    })
                }
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultCook.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCook.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCook.SecondTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultCook.TotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCook.TotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCook.TotalSum)
            })
        }

        SheetData.push(RevenueData)
        RevenueData = []

        //Повара 2 группа        
        RevenueData.push('Итого повара (группа 2) руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultCookSecondGroup.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultCookSecondGroup.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultCookSecondGroup.Result[el.id])
                    })
                }  
            return(el)
        })

        RevenueData.push('')
        if(isNumber(parseFloat(ResultCookSecondGroup.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCookSecondGroup.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCookSecondGroup.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого повара (группа 2) руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultCookSecondGroup.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultCookSecondGroup.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                            t: "s",
                        v: String(ResultCookSecondGroup.Result[el.id])
                    })
                }
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultCookSecondGroup.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCookSecondGroup.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCookSecondGroup.SecondTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultCookSecondGroup.TotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultCookSecondGroup.TotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultCookSecondGroup.TotalSum)
            })
        }

        SheetData.push(RevenueData)
        RevenueData = []

        //Управляющие
        RevenueData.push('Итого управление руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultManager.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultManager.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultManager.Result[el.id])
                    })
                }  
            return(el)
        })

        RevenueData.push('')
        if(isNumber(parseFloat(ResultManager.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultManager.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultManager.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого управление руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultManager.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultManager.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultManager.Result[el.id])
                    })
                }  
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultManager.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultManager.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultManager.SecondTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultManager.TotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultManager.TotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultManager.TotalSum)
            })
        }

        SheetData.push(RevenueData)
        RevenueData = []

        //Без %

        RevenueData.push('Итого кухрабочие и стажеры руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultOther.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultOther.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultOther.Result[el.id])
                    })
                }  
            return(el)
        })

        RevenueData.push('')
        
        if(isNumber(parseFloat(ResultOther.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultOther.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultOther.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого кухрабочие и стажеры руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultOther.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultOther.Result[el.id])
                        })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultOther.Result[el.id])
                    })
                }  
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultOther.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultOther.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultOther.SecondTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultOther.TotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultOther.TotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultOther.TotalSum)
            })
        }

        SheetData.push(RevenueData)
        RevenueData = []

        //Итог ФОТ руб
        RevenueData.push('Итого ФОТ руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el) => {
            if(el.id < 15)
                if(isNumber(parseFloat(ResultFOT.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultFOT.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultFOT.Result[el.id])
                    })
                }  
            return(el)
        })

        RevenueData.push('')
        if(isNumber(parseFloat(ResultFOT.FirstTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultFOT.FirstTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultFOT.FirstTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Итого ФОТ руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')

        RevenueArray.map((el) => {
            if(el.id > 14)
                if(isNumber(parseFloat(ResultFOT.Result[el.id])))
                {
                    RevenueData.push({
                        t: "n",
                        v: parseFloat(ResultFOT.Result[el.id])
                    })
                }
                else
                {
                    RevenueData.push({
                        t: "s",
                        v: String(ResultFOT.Result[el.id])
                    })
                }  
            return(el)
        })
        RevenueData.push('')

        if(isNumber(parseFloat(ResultFOT.SecondTotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultFOT.SecondTotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultFOT.SecondTotalSum)
            })
        }

        RevenueData.push('')
        RevenueData.push('')
        if(isNumber(parseFloat(ResultFOT.TotalSum)))
        {
            RevenueData.push({
                t: "n",
                v: parseFloat(ResultFOT.TotalSum)
            })
        }
        else
        {
            RevenueData.push({
                t: "s",
                v: String(ResultFOT.TotalSum)
            })
        }
        SheetData.push(RevenueData)
        RevenueData = []

            //Касса %
            SheetData.push('')

            RevenueData.push('Итого касса %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
            if(el.id < 15)
            RevenueData.push(
                (parseFloat(ResultKashier.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
            return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultKashier.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого касса %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
            if(el.id > 14)
            RevenueData.push(
                (parseFloat(ResultKashier.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
            return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultKashier.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultKashier.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            SheetData.push(RevenueData)
            RevenueData = []

            //Повара (группа 1) %

            RevenueData.push('Итого повара (группа 1) %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
            if(el.id < 15)
            RevenueData.push(
                (parseFloat(ResultCook.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
                return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultCook.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого повара (группа 1) %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
            if(el.id > 14)
            RevenueData.push(
                (parseFloat(ResultCook.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
                return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultCook.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultCook.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            SheetData.push(RevenueData)
            RevenueData = []

            //Повара (группа 2) %

            RevenueData.push('Итого повара (группа 2) %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
            if(el.id < 15)
            RevenueData.push(
                (parseFloat(ResultCookSecondGroup.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
                return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultCookSecondGroup.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого повара (группа 2) %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
            if(el.id > 14)
            RevenueData.push(
                (parseFloat(ResultCookSecondGroup.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
            )
                return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultCookSecondGroup.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultCookSecondGroup.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            SheetData.push(RevenueData)
            RevenueData = []

            //Управление %

            RevenueData.push('Итого управление %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
                if(el.id < 15)
                RevenueData.push(
                    (parseFloat(ResultManager.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultManager.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого управление %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
                if(el.id > 14)
                RevenueData.push(
                    (parseFloat(ResultManager.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultManager.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultManager.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            SheetData.push(RevenueData)
            RevenueData = []

            //Без % %

            RevenueData.push('Итого кухрабочие и стажеры %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
                if(el.id < 15)
                RevenueData.push(
                    (parseFloat(ResultOther.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultOther.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого кухрабочие и стажеры %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
                if(el.id > 14)
                RevenueData.push(
                    (parseFloat(ResultOther.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultOther.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultOther.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            SheetData.push(RevenueData)
            RevenueData = []

            //Итого ФОТ %

            RevenueData.push('Итого ФОТ %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')
            RevenueArray.map((el) => {
                if(el.id < 15)
                RevenueData.push(
                    (parseFloat(ResultFOT.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })

            RevenueData.push('')
            RevenueData.push(
            ((ResultFOT.FirstTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )

            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('Итого ФОТ %')
            RevenueData.push('')
            RevenueData.push('')
            RevenueData.push('')

            RevenueArray.map((el) => {
                if(el.id > 14)
                RevenueData.push(
                    (parseFloat(ResultFOT.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2) + "%"
                )
                return(el)
            })
            RevenueData.push('')

            RevenueData.push(
            ((ResultFOT.SecondTotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            
            RevenueData.push('')
            RevenueData.push('')

            RevenueData.push(
            ((ResultFOT.TotalSum / 
                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                    : SumRevenue, 0
                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
            ).toFixed(2) + "%"
            )
            SheetData.push(RevenueData)
            RevenueData = []

            //опции филиала
        SheetData.push('')
        SheetData.push('')
        SheetData.push('')
        SheetData.push(['% на кассиров', {t: "n", v: PercentCity.Kashier}])
        SheetData.push(['% на поваров (группа 1)', {t: "n", v: PercentCity.Cook}])
        SheetData.push(['% на поваров (группа 2)', {t: "n", v: PercentCity.CookSecondGroup}])
        SheetData.push(['Сумма выручки для премирования', {t: "n", v: PercentCity.PrizeMinSum}])
        SheetData.push(['Премия кассиров от выручки', {t: "n", v: PercentCity.PrizeSumKashier}])
        SheetData.push(['Премия поваров (группа 1) от выручки', {t: "n", v: PercentCity.PrizeSumCook}])
        SheetData.push(['Премия поваров (группа 2) от выручки', {t: "n", v: PercentCity.PrizeSumCookSecondGroup}])
        SheetData.push(['Коэффициент выручки %', {t: "n", v: PercentCity.RatioRevenue}])
        SheetData.push('')
        SheetData.push('')
        SheetData.push('')



        SheetData.push(['Расчет часов и %'])

        RevenueData.push('Кассиры часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffKashierArray.map((el, index) => 
            index < 15 && index > Period.MinDay && index < Period.MaxDay &&
                RevenueData.push({t: 'n', v: el})

        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Кассиры часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffKashierArray.map((el, index) => 
            index > 14 && index > Period.MinDay && index < Period.MaxDay &&
            RevenueData.push({t: 'n', v: el})
        )
        SheetData.push(RevenueData)
        RevenueData = []

        RevenueData.push('Повара (группа 1) часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffCookArray.map((el, index) => 
            index < 15 && index > Period.MinDay && index < Period.MaxDay &&
            RevenueData.push({t: 'n', v: el})
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Повара (группа 1) часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffCookArray.map((el, index) => 
            index > 14 && index > Period.MinDay && index < Period.MaxDay &&
            RevenueData.push({t: 'n', v: el})
        )
        SheetData.push(RevenueData)
        RevenueData = []

        RevenueData.push('Повара (группа 2) часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffCookSecondGroupArray.map((el, index) => 
            index < 15 && index > Period.MinDay && index < Period.MaxDay &&
            RevenueData.push({t: 'n', v: el})
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Повара (группа 2) часов')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        HoursStaffCookSecondGroupArray.map((el, index) => 
            index > 14 && index > Period.MinDay && index < Period.MaxDay &&
            RevenueData.push({t: 'n', v: el})
        )
        SheetData.push(RevenueData)
        RevenueData = []

        
        RevenueData.push('Сумма % на кассиров')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(el.Value > 0)
                {
                    (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2) !== 'Infinity') 
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
        }
        )

        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Сумма % на кассиров')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index > 14 && index > Period.MinDay && index < Period.MaxDay)
                if(el.Value > 0)
                {
                    (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2) !== 'Infinity') 
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
        }
        )
        SheetData.push(RevenueData)
        RevenueData = []

        
        RevenueData.push('Сумма % на поваров (группа 1)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(el.Value > 0)
                    {
                        (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2) !== 'Infinity')
                        ?
                        RevenueData.push({
                            t: 'n', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2)
                        })
                        :
                        RevenueData.push({
                            t: 's', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2)
                        })
                    }
                    else
                    {
                        RevenueData.push({
                            t: 'n', 
                            v: 0
                        })
                    }
                    return(el)
                }
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Сумма % на поваров (группа 1)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
                if(index > 14 && index > Period.MinDay && index < Period.MaxDay) 
                    if(el.Value > 0)
                    {
                        (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2) !== 'Infinity')
                        ?
                        RevenueData.push({
                            t: 'n', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2)
                        })
                        :
                        RevenueData.push({
                            t: 's', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2)
                        })
                    }
                    else
                    {
                        RevenueData.push({
                            t: 'n', 
                            v: 0
                        })
                    }
                    return(el)
            }
        )
        SheetData.push(RevenueData)
        RevenueData = []

        RevenueData.push('Сумма % на поваров (группа 2)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(el.Value > 0)
                    {
                        (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2) !== 'Infinity')
                        ?
                        RevenueData.push({
                            t: 'n', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2)
                        })
                        :
                        RevenueData.push({
                            t: 's', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2)
                        })
                    }
                    else
                    {
                        RevenueData.push({
                            t: 'n', 
                            v: 0
                        })
                    }
                    return(el)
                }
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Сумма % на поваров (группа 2)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
                if(index > 14 && index > Period.MinDay && index < Period.MaxDay) 
                    if(el.Value > 0)
                    {
                        (parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2) !== 'Nan' && parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2) !== 'Infinity')
                        ?
                        RevenueData.push({
                            t: 'n', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2)
                        })
                        :
                        RevenueData.push({
                            t: 's', 
                            v: parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2)
                        })
                    }
                    else
                    {
                        RevenueData.push({
                            t: 'n', 
                            v: 0
                        })
                    }
                    return(el)
            }
        )
        SheetData.push(RevenueData)
        RevenueData = []



        RevenueData.push('В час на кассиров')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                }
                return(el)
            }                    
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('В час на кассиров')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index > 14 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2)
                    })
                }
                return(el)
            }
        )
        SheetData.push(RevenueData)
        RevenueData = []


        RevenueData.push('В час на поваров (группа 1)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
            }
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('В час на поваров (группа 1)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index > 14 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
            }
        )
        SheetData.push(RevenueData)
        RevenueData = []

        RevenueData.push('В час на поваров (группа 2)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index < 15 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
            }
        )
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('В час на поваров (группа 2)')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        RevenueArray.map((el, index) => {
            if(index > 14 && index > Period.MinDay && index < Period.MaxDay)
                if(HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 && el.Value > 0)
                {
                    (parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2) !== 'Nan' && parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2) !== 'Infinity')
                    ?
                    RevenueData.push({
                        t: 'n', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2)
                    })
                    :
                    RevenueData.push({
                        t: 's', 
                        v: parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2)
                    })
                }
                else
                {
                    RevenueData.push({
                        t: 'n', 
                        v: 0
                    })
                }
                return(el)
            }
        )
        SheetData.push(RevenueData)
        RevenueData = []

        SheetData.push('')
        SheetData.push('')
        SheetData.push('')

        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Кассир' && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&  item.id < 15 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay && item.id > 14 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0
                        ).toFixed(2) 
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })


        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if((el.Post === 'Повар' || el.Post === 'Повар 1 группа') && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&  item.id < 15 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay && item.id > 14 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0
                        ).toFixed(2) 
                })
            SheetData.push(RevenueData)
            RevenueData = []
            }
            return(el)
        })

        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет %')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Повар 2 группа' && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay &&  item.id < 15 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a, index) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]) * a.Value).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                        item.id > Period.MinDay && item.id < Period.MaxDay && item.id > 14 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 
                        ? 
                        Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) 
                        : 
                        Sum + 0, 0
                        ).toFixed(2) 
                })
            SheetData.push(RevenueData)
            RevenueData = []
            }
            return(el)
        })

        SheetData.push('')
        SheetData.push('')
        SheetData.push('')


        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Касса')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Кассир' && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(a.Value / el.Shift)).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => item.id < 15 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ?
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.Shift)) 
                    : 
                    Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(a.Value / el.SecondShift)).toFixed(2) 
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                    item.id > 14 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ? 
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumKashier) * parseFloat(item.Value / el.SecondShift)) 
                    :
                    Sum + 0, 0).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
            }
            return(el)
        })

        
        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 1)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if((el.Post === 'Повар' || el.Post === 'Повар 1 группа') && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(a.Value / el.Shift)).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => item.id < 15 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ?
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.Shift)) 
                    : 
                    Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(a.Value / el.SecondShift)).toFixed(2) 
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                    item.id > 14 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ? 
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCook) * parseFloat(item.Value / el.SecondShift)) 
                    :
                    Sum + 0, 0).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
                
            }
            return(el)
        })

        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id < 15)
            {
                if(el.id === 0)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('Просчет премиальных')
        RevenueData.push('')
        RevenueData.push('')
        RevenueData.push('')
        await RevenueArray.map((el) => {
            if(el.id > 14)
            {
                if(el.id === 15)
                {
                    RevenueData.push('Повара (группа 2)')
                }
                else
                {
                    RevenueData.push('')
                }
            }
            return(el)
        })
        RevenueData.push('')
        RevenueData.push('Сумма руб.')

        SheetData.push(RevenueData)
        RevenueData = []
        
        StaffSelectedCityArray.map((el) => {
            if(el.Post === 'Повар 2 группа' && el.Hidden !== true) 
            {
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(a.Value / el.Shift)).toFixed(2)
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => item.id < 15 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ?
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.Shift)) 
                    : 
                    Sum + 0, 0).toFixed(2)
                })
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push(el.FIO)
                RevenueData.push('')
                RevenueData.push('')
                RevenueData.push('')
                el.Hours.map((a) => {
                    if(a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay)
                    {
                        if(parseFloat(RevenueArray[a.id].Value) > PercentCity.PrizeMinSum)
                        {
                                RevenueData.push({
                                    t: "n",
                                    v: parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(a.Value / el.SecondShift)).toFixed(2) 
                                })
                        }
                        else
                        {
                            RevenueData.push({
                                t: "n",
                                v: 0
                            })
                        }
                    }
                    return(a)
                })
                RevenueData.push('')
                RevenueData.push({
                    t: "n",
                    v: el.Hours.reduce((Sum, item) => 
                    item.id > 14 && item.Value > 0 && parseFloat(RevenueArray[item.id].Value) > PercentCity.PrizeMinSum 
                    ? 
                    Sum + parseFloat(parseFloat(PercentCity.PrizeSumCookSecondGroup) * parseFloat(item.Value / el.SecondShift)) 
                    :
                    Sum + 0, 0).toFixed(2)
                })
                SheetData.push(RevenueData)
                RevenueData = []
                
            }
            return(el)
        })
    }

    const handleClickExport = () => {
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(SheetData)

        XLSX.utils.book_append_sheet(wb, ws, SelectedMonth.Name)
        let CityName = ''

        if(SelectedCity.Name) {
            CityName = SelectedCity.Name
        } else {
            CityName = `${SelectedCity.City} ${SelectedCity.Adress}`
        }
        
        XLSX.writeFile(wb, `${CityName} ${SelectedMonth.Name}.xlsx`)
    }

    return(
        <button
        className="RevenueMenuButton"
        onClick={(async () => {
            await getData()
            if(SheetData.length > 0)
            handleClickExport()
        })}
        onTouchStart={() => {
            setCancelTouch(false)
        }}
        onTouchMove={() => {
            setCancelTouch(true)
        }}
        onTouchCancel={() => {
            setCancelTouch(true)
        }}
        onTouchEnd={async (event) => {
            event.preventDefault()
            if(!CancelTouch)
            {
                await getData()
                if(SheetData.length > 0)
                handleClickExport()
            }
        }}
        >
            Экспортировать
        </button>
    )
}

export default ExportXlsx;
